const en = `<p>Speed up things at reception and fill in the medical history
form right now. You can also fill in the medical history form at our reception
after signing in.</p>`;

const fi = `<p>Nopeuta asiointia vastaanotolla ja täytä esitiedot jo nyt. Voit
täyttää esitiedot myös ilmoittautumisen jälkeen vastaanotollamme.</p>`;

export const anamnesisInfo = (lang) => (lang === 'fi' ? fi : en);



// WEBPACK FOOTER //
// ./src/data/anamnesis.js